import { render, staticRenderFns } from "./CatalogInput.vue?vue&type=template&id=361d65d2&"
import script from "./CatalogInput.vue?vue&type=script&lang=ts&"
export * from "./CatalogInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports